import React, { type FC } from "react";
import clsx from "clsx";
import { useTranslations } from "next-intl";
import { IcAppleStore, IcGooglePlay } from "~/src/assets/icon";
import { DOWNLOAD_AVACUS_LINK } from "~/src/utils/common";
import { openWebsite } from "~/src/utils/link-safety";

const stores = [
  {
    label: "App Store",
    alt: "Apple Store",
    icon: IcAppleStore,
    caption: "web.available_on_the",
    url: DOWNLOAD_AVACUS_LINK.IOS,
  },
  {
    label: "Google Play",
    alt: "Google Play",
    icon: IcGooglePlay,
    caption: "web.get_it_on",
    url: DOWNLOAD_AVACUS_LINK.ANDROID,
  },
];

const DownloadAvacusApp: FC<{
  align?: "start" | "center";
  className?: string;
}> = ({ align = "center", className = "font-medium" }) => {
  const t = useTranslations();
  const alignment = align === "start" ? "justify-start" : "justify-center";
  return (
    <div className={clsx("flex items-center", alignment)}>
      <div
        className={clsx(
          "flex flex-row items-center gap-4",
          alignment,
          className
        )}
      >
        {stores.map((store) => (
          <button
            key={store.label}
            onClick={() => {
              openWebsite(store.url);
            }}
            className="z-10 flex justify-start items-center bg-black border-1.5 border-gray2 rounded-[10px] py-1 px-3 transition ease-in-out duration-300 active:scale-95"
          >
            <img src={store.icon} alt={store.alt} className="w-6" />
            <div className="block text-white ml-3 font-sans text-start">
              <p className="text-[10px] leading-[12.55px] tracking-normal">
                {t(store.caption)}
              </p>
              <p className="text-base tracking-normal">{store.label}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};
export default DownloadAvacusApp;
